// extracted by css-extract-rspack-plugin
export default {"InfoLink":"ExpressionWidgetInfo-module__InfoLink___gleRs","TooltipLabel":"ExpressionWidgetInfo-module__TooltipLabel___yJLZU"};